import type { BackendApi } from './api';

export async function fetchDocumentContentBlob(
    api: BackendApi,
    path: string,
    params: Record<string, string>,
): Promise<Blob> {
    const response = await api.get(path, params);
    if (!response.ok) {
        throw new Error(`Failed to load document content: ${response.statusText}`);
    }
    return await response.blob();
}
